
































































import {Component, Inject, Mixins, Prop, Watch} from 'vue-property-decorator';
import EditableResultMixins from '@/mixins/plan/edit/PlanEditResultMixin';
import Draggable from 'vuedraggable';
import TabContentEdit from './PlanEditResultEditTabContent.vue';
import TabsEditNameEditDialog from './PlanEditResultEditTabsNameEditDialog.vue';
import {PlanEditResultConfigTab} from '@/models/PlanEditResultConfigModel';
import PlanEditResultConfigTabTypesEnum from '@/enums/PlanEditResultConfigTabTypesEnum';
import {mapMutations, mapState} from 'vuex';

@Component({
    components: {
        Draggable,
        TabContentEdit,
        TabsEditNameEditDialog,
    },
    computed: {
        ...mapState('planEditResultEdit', ['currentTabs', 'activeTabs']),
    },
    methods: {
        ...mapMutations('planEditResultEdit', ['updateCurrentTabs', 'updateActiveTabs']),
    },
})
export default class TabsEdit extends Mixins(EditableResultMixins) {
    @Prop() tabs!: PlanEditResultConfigTab[];
    @Prop() depth!: number;
    @Inject() getFormRef!: Function;

    public currentTabs!: any[];
    public updateCurrentTabs!: Function;
    public activeTabs!: any[];
    public updateActiveTabs!: Function;

    private draggedIndex: number = -1;
    private tabIndex: number = 0;
    private hideSlider: boolean = false;
    private tabContent: any = false;
    private tabKey: string = '';
    private TabTypes = PlanEditResultConfigTabTypesEnum;
    private localCurrentTabs: PlanEditResultConfigTabTypesEnum[] = [];

    get localTabs() {
        return this.tabs;
    }

    set localTabs(value: PlanEditResultConfigTab[]) {
        this.$emit('update:tabs', value);
    }

    get tabsConfig() {
        let tabTypes = this.localCurrentTabs.flat();
        let tabs = [{text: this.$t('Documents.Plan.User'), type: PlanEditResultConfigTabTypesEnum.User}];
        if (!tabTypes.includes(PlanEditResultConfigTabTypesEnum.Shift))
            tabs.push({text: this.$t('Documents.PlanRes.ShiftTabs'), type: PlanEditResultConfigTabTypesEnum.Shift});
        if (!tabTypes.includes(PlanEditResultConfigTabTypesEnum.Equipment))
            tabs.push({
                text: this.$t('Documents.PlanRes.EquipmentTabs'),
                type: PlanEditResultConfigTabTypesEnum.Equipment,
            });
        if (!tabTypes.includes(PlanEditResultConfigTabTypesEnum.WarehouseVeneer))
            tabs.push({
                text: this.$t('Documents.PlanRes.WarehouseVeneerTabs'),
                type: PlanEditResultConfigTabTypesEnum.WarehouseVeneer,
            });
        return tabs;
    }

    @Watch('currentTabs', {deep: true})
    onCurrentTabsChange(value: PlanEditResultConfigTabTypesEnum[]) {
        this.localCurrentTabs = value.slice(1, this.depth + 1);
    }

    @Watch('tabs', {deep: true, immediate: true})
    onTabsChange(value: PlanEditResultConfigTab[]) {
        let currentTabs = this.currentTabs.slice();
        let activeTabs = this.activeTabs.slice();

        currentTabs[this.depth] = this.tabs.map(tab => tab.type);
        this.updateCurrentTabs(currentTabs);
        if (value.length > 0) {
            let tab = this.tabs.find((item, index) => index === this.tabIndex);
            if (tab) {
                this.tabContent = tab.content;
                this.tabKey = tab.name + this.tabIndex;

                activeTabs[this.depth] = tab.type;
            }
        } else {
            this.tabContent = null;
            this.tabKey = '';

            activeTabs[this.depth] = null;
        }
        this.updateActiveTabs(activeTabs);
    }

    @Watch('tabIndex')
    async onTabIndexChange(value: number, oldValue: number) {
        let tab = this.tabs.find((item, index) => index === value);
        if (tab) {
            this.tabContent = tab.content;
            this.tabKey = tab.name + this.tabIndex;
            let arr = this.activeTabs.slice();
            arr[this.depth] = tab.type;
            this.updateActiveTabs(arr);
        }
    }

    @Watch('tabContent', {deep: true})
    onTabContentChange(value: any, oldValue: any) {
        if (value === null) return;
        let tabs = this.tabs.slice();
        tabs[this.tabIndex].content = value;
        this.$emit('update:tabs', tabs);
    }

    destroyed() {
        let activeTabs = this.activeTabs.slice(),
            currentTabs = this.currentTabs.slice();
        activeTabs[this.depth] = null;
        this.updateActiveTabs(activeTabs);
        currentTabs[this.depth] = [];
        this.updateCurrentTabs(currentTabs);
    }

    onEnd(event: any) {
        if (this.tabIndex === event.oldIndex) this.tabIndex = event.newIndex;
        else if (
            this.tabIndex >= event.oldIndex && // right shift
            this.tabIndex <= event.newIndex
        ) {
            this.tabIndex -= 1;
        } else if (
            this.tabIndex <= event.oldIndex && // left shift
            this.tabIndex >= event.newIndex
        ) {
            this.tabIndex += 1;
        }
        this.draggedIndex = event.newIndex;
        this.hideSlider = false;
    }

    async onTabClick(tab: PlanEditResultConfigTab, index: number) {
        if (this.tabIndex === index) return;
        if (!this.getFormRef().validate()) {
            this.$toasted.error(this.$t('Common.Messages.PlsFillInAllFields') as string, {
                icon: 'mdi-message-alert',
                position: 'top-left',
            });
            return;
        }
        this.tabIndex = index;
    }

    async addTab(type: PlanEditResultConfigTabTypesEnum) {
        if (!this.getFormRef().validate()) {
            this.$toasted.error(this.$t('Common.Messages.PlsFillInAllFields') as string, {
                icon: 'mdi-message-alert',
                position: 'top-left',
            });
            return;
        }
        let tab = this.getTabData(type);
        if (type === PlanEditResultConfigTabTypesEnum.User)
            (this.$refs.edit as any).open(
                {name: ''},
                {
                    saveCallback: async (data: any) => {
                        tab.name = data.name;
                        this.localTabs = [...this.localTabs.slice(), tab];
                        (this.$refs.edit as any).close();
                        await this.$nextTick();
                        this.tabIndex = this.localTabs.length - 1;
                    },
                },
            );
        else {
            this.localTabs = [...this.localTabs.slice(), tab];
            await this.$nextTick();
            this.tabIndex = this.localTabs.length - 1;
        }
    }

    getTabData(type: PlanEditResultConfigTabTypesEnum): PlanEditResultConfigTab {
        switch (type) {
            case PlanEditResultConfigTabTypesEnum.User:
                return {
                    name: 'Documents.Plan.User',
                    content: [],
                    type: PlanEditResultConfigTabTypesEnum.User,
                };
            case PlanEditResultConfigTabTypesEnum.Equipment:
                return {
                    name: 'Documents.PlanRes.EquipmentTabs',
                    content: [],
                    type: PlanEditResultConfigTabTypesEnum.Equipment,
                };
            case PlanEditResultConfigTabTypesEnum.Shift:
                return {
                    name: 'Documents.PlanRes.ShiftTabs',
                    content: [],
                    type: PlanEditResultConfigTabTypesEnum.Shift,
                };
            case PlanEditResultConfigTabTypesEnum.WarehouseVeneer:
                return {
                    name: 'Documents.PlanRes.WarehouseVeneerTabs',
                    content: [],
                    type: PlanEditResultConfigTabTypesEnum.WarehouseVeneer,
                };
            default:
                throw Error('invalid type');
        }
    }

    deleteTab(order: number) {
        this.localTabs = this.localTabs.filter((tab, index) => order !== index);
    }

    onRename(tab: PlanEditResultConfigTab) {
        (this.$refs.edit as any).open(
            {name: tab.name},
            {
                saveCallback: async (data: any) => {
                    tab.name = data.name;
                    (this.$refs.edit as any).close();
                },
            },
        );
    }
}
